import React from 'react';
import './JoinTeam.css';

function JoinTeam() {
  return (
    <section className="join-team">
      <div className="join-team-content" data-reveal>
        <h2 className="join-team-title">Join our team</h2>
        <p className="join-team-subtitle">
        Interested in interning, visiting, or working with our group? <br />
          Send an email to <a href="mailto:happy1@utexas.edu">happy1@utexas.edu</a> and <a href="mailto:dalmann@utexas.edu">dalmann@utexas.edu</a>.
        </p>
      </div>
    </section>
  );
}

export default JoinTeam; 